export const INTELBRAS = {
  id: "intelbras",
  name: "INTELBRAS",
  imageFolder: "/intelbras",
  tagline: {
    pt: "Soluções completas para empresas e outros negócios.",
    en: "Complete solutions for companies and other businesses.",
    es: "Soluciones completas para empresas y otros negocios.",
  },
  color: "#00a859",
  theme: {
    bgGradient: "from-[#d6e6f2] via-[#d8e8f5] to-[#e9f4ed]",
    blob1: "bg-emerald-200/30",
    blob2: "bg-blue-200/40",
    overlineText: "text-emerald-700",
    pillarPill: "border-emerald-300 text-emerald-700",
    segmentHover: "hover:border-emerald-300",
    tabHover: "hover:border-emerald-300 hover:text-emerald-700",
    ctaPrimary:
      "bg-emerald-600 hover:bg-emerald-700 shadow-emerald-600/25 hover:shadow-emerald-600/40",
    ctaOutline:
      "border-emerald-300 text-emerald-700 hover:bg-emerald-50",
    productHover: "hover:border-emerald-300",
    productQuoteCta: "border-emerald-300 text-emerald-700 hover:bg-emerald-50",
    productBadge: "text-emerald-700",
    productPreviewPill: "text-emerald-700",
    whyPanel: "border-emerald-200 from-emerald-50 to-white",
    whyItemBorder: "border-emerald-100",
    whyCheck: "text-emerald-600",
    modalHeaderBg: "from-emerald-50 via-[#d8e8f5] to-blue-50",
    modalBrandBadge: "border-emerald-200 text-emerald-700",
    modalInputFocus:
      "focus:border-emerald-500 focus:ring-emerald-500/20",
    modalSubmit:
      "bg-emerald-600 hover:bg-emerald-700 shadow-emerald-600/25 hover:shadow-emerald-600/40",
  },
  pillars: {
    pt: ["Segurança", "Conectividade", "Energia"],
    en: ["Security", "Connectivity", "Energy"],
    es: ["Seguridad", "Conectividad", "Energía"],
  },
  segments: {
    pt: [
      { name: "Condomínios", desc: "Controlo de acesso, monitorização perimetral, backup de energia e conectividade total." },
      { name: "Restaurantes", desc: "Monitorização, gestão de estacionamento, prevenção de incêndio e conectividade para equipa e clientes." },
      { name: "Mercados", desc: "Segurança do perímetro, controlo de stock, alarmes e backup de energia para os sistemas." },
      { name: "Lojas", desc: "Proteção da loja, controlo do stock, alarmes contra incêndio e conectividade dos sistemas de segurança." },
      { name: "Barbearias", desc: "Monitorização do salão, acesso a produtos, backup de energia e Wi-Fi de qualidade para clientes." },
      { name: "Academias", desc: "Controlo de acessos, monitorização de salas, alarmes de emergência e conectividade para alunos." },
      { name: "Clínicas Médicas", desc: "Acesso a salas, monitorização de recepção, nobreaks para equipamentos e rede estável." },
    ],
    en: [
      { name: "Condominiums", desc: "Access control, perimeter monitoring, power backup and total connectivity." },
      { name: "Restaurants", desc: "Monitoring, parking management, fire prevention and connectivity for staff and guests." },
      { name: "Supermarkets", desc: "Perimeter security, stock control, alarms and power backup for all systems." },
      { name: "Retail stores", desc: "Store protection, stock control, fire alarms and connected security systems." },
      { name: "Barber shops", desc: "Salon monitoring, product access control, power backup and quality Wi-Fi for clients." },
      { name: "Gyms", desc: "Access control, room monitoring, emergency alarms and connectivity for members." },
      { name: "Medical clinics", desc: "Room access, reception monitoring, UPS for equipment and reliable network." },
    ],
    es: [
      { name: "Condominios", desc: "Control de accesos, monitoreo perimetral, respaldo de energía y conectividad total." },
      { name: "Restaurantes", desc: "Monitoreo, gestión de estacionamiento, prevención de incendios y conectividad." },
      { name: "Supermercados", desc: "Seguridad perimetral, control de stock, alarmas y respaldo de energía." },
      { name: "Tiendas", desc: "Protección de la tienda, control de stock, alarmas y sistemas conectados." },
      { name: "Barberías", desc: "Monitoreo del salón, control de acceso a productos, respaldo de energía y Wi-Fi." },
      { name: "Gimnasios", desc: "Control de accesos, monitoreo, alarmas de emergencia y conectividad para miembros." },
      { name: "Clínicas médicas", desc: "Acceso a salas, monitoreo, UPS para equipos y red estable." },
    ],
  },
  why: {
    pt: {
      title: "Porquê escolher a Intelbras?",
      items: [
        "Portfólio completo para todas as soluções",
        "Produtos com qualidade reconhecida",
        "Assistência técnica em Angola",
        "Suporte técnico especializado",
        "Marca internacional consolidada",
      ],
    },
    en: {
      title: "Why choose Intelbras?",
      items: [
        "Complete portfolio across every solution",
        "Recognised product quality",
        "Local technical support in Angola",
        "Specialised engineering team",
        "Consolidated international brand",
      ],
    },
    es: {
      title: "¿Por qué elegir Intelbras?",
      items: [
        "Portafolio completo en todas las soluciones",
        "Productos de calidad reconocida",
        "Asistencia técnica local en Angola",
        "Equipo especializado",
        "Marca internacional consolidada",
      ],
    },
  },
  groups: [
    {
      id: "infinity-solution",
      icon: "phone",
      featured: true,
      video: "9OoXTLiJLrU",
      title: {
        pt: "Infinity Solution — PABX IP",
        en: "Infinity Solution — IP PBX",
        es: "Infinity Solution — PABX IP",
      },
      description: {
        pt: "Plataforma de comunicação IP Intelbras baseada em softswitch, com arquitetura modular e gateways integrados. Permite migração simples para o mundo IP e cresce com a empresa — investimento certo na hora certa.",
        en: "Intelbras IP communication platform built on a softswitch core with modular architecture and integrated gateways. Enables a smooth migration to IP and scales with your business — the right investment at the right time.",
        es: "Plataforma de comunicación IP Intelbras basada en softswitch, con arquitectura modular y gateways integrados. Permite una migración simple al mundo IP y crece con tu empresa.",
      },
      specs: {
        pt: [
          "Até 500 ramais IP",
          "Até 640 ramais TDM (analógico e digital)",
          "Até 120 canais E1 (R2 / ISDN)",
          "Troncos SIP (depende do tipo de conexão)",
          "Suporte a múltiplos sites",
        ],
        en: [
          "Up to 500 IP extensions",
          "Up to 640 TDM extensions (analog and digital)",
          "Up to 120 E1 channels (R2 / ISDN)",
          "SIP trunks (depending on connection type)",
          "Multi-site support",
        ],
        es: [
          "Hasta 500 extensiones IP",
          "Hasta 640 extensiones TDM (analógicas y digitales)",
          "Hasta 120 canales E1 (R2 / ISDN)",
          "Troncales SIP (según tipo de conexión)",
          "Soporte multi-sitio",
        ],
      },
      highlights: {
        pt: [
          "Acesso e gestão remotos",
          "Roteamento inteligente de chamadas",
          "Controlo de custos (conta e senha)",
          "Sala virtual de conferência de voz (até 10 salas com 10 participantes)",
          "Identificação de chamadas",
          "Integração de correio de voz com e-mail",
          "Bilhetagem (CDR)",
          "Agenda geral",
          "Atendimento automático (DISA)",
          "Estacionamento de chamadas",
          "Linha executiva",
          "Demais facilidades essenciais de PABX",
        ],
        en: [
          "Remote access and management",
          "Intelligent call routing",
          "Cost control (account & PIN)",
          "Virtual voice-conference rooms (up to 10 rooms × 10 participants)",
          "Caller ID",
          "Voicemail-to-email integration",
          "Call detail records (CDR)",
          "Global directory",
          "Automated attendant (DISA)",
          "Call parking",
          "Executive line",
          "All essential PBX facilities",
        ],
        es: [
          "Acceso y gestión remotos",
          "Enrutamiento inteligente de llamadas",
          "Control de costes (cuenta y contraseña)",
          "Sala virtual de conferencia de voz (hasta 10 salas × 10 participantes)",
          "Identificación de llamadas",
          "Integración buzón de voz con email",
          "Facturación (CDR)",
          "Agenda global",
          "Atención automática (DISA)",
          "Estacionamiento de llamadas",
          "Línea ejecutiva",
          "Todas las facilidades esenciales de PABX",
        ],
      },
      products: [
        {
          slug: "infinity-softswitch",
          pt: "Infinity Softswitch — Núcleo da plataforma de comunicação IP",
          en: "Infinity Softswitch — Core of the IP communication platform",
          es: "Infinity Softswitch — Núcleo de la plataforma de comunicación IP",
        },
        {
          slug: "infinity-extension",
          pt: "Infinity Extension — Gateway de voz analógico/digital integrado",
          en: "Infinity Extension — Integrated analog/digital voice gateway",
          es: "Infinity Extension — Gateway de voz analógico/digital integrado",
        },
      ],
    },
    {
      id: "cip-92200",
      icon: "phone",
      featured: true,
      video: "veipx8WmXDM",
      title: {
        pt: "CIP 92200 — Central IP All-in-One",
        en: "CIP 92200 — All-in-One IP PBX",
        es: "CIP 92200 — Central IP All-in-One",
      },
      description: {
        pt: "Central IP Intelbras robusta e altamente customizável, com gateways integrados num único equipamento. Atende ao ambiente corporativo de forma flexível e adapta-se ao crescimento da empresa.",
        en: "Robust, highly customisable Intelbras IP PBX with integrated gateways in a single appliance. Delivers flexibility for corporate environments and scales with the business.",
        es: "Central IP Intelbras robusta y altamente personalizable, con gateways integrados en un único equipo. Atiende al entorno corporativo de forma flexible y crece con la empresa.",
      },
      specs: {
        pt: [
          "Até 400 utilizadores IP",
          "Até 60 canais E1 (R2 / ISDN)",
          "Até 32 interfaces analógicas (FXS / FXO)",
          "Troncos SIP (depende do tipo de conexão)",
          "Montagem em rack 19\"",
          "Programador web bilíngue (PT / ES)",
        ],
        en: [
          "Up to 400 IP users",
          "Up to 60 E1 channels (R2 / ISDN)",
          "Up to 32 analog interfaces (FXS / FXO)",
          "SIP trunks (depending on connection type)",
          "19\" rack mount",
          "Bilingual web programmer (PT / ES)",
        ],
        es: [
          "Hasta 400 usuarios IP",
          "Hasta 60 canales E1 (R2 / ISDN)",
          "Hasta 32 interfaces analógicas (FXS / FXO)",
          "Troncales SIP (según tipo de conexión)",
          "Montaje en rack 19\"",
          "Programador web bilingüe (PT / ES)",
        ],
      },
      highlights: {
        pt: [
          "Distribuidor Automático de Chamadas (DAC)",
          "Atendedor Automático de Chamadas (DISA)",
          "Correio de voz",
          "Salas de audioconferência",
          "Roteamento inteligente de chamadas",
          "Suporte a fax T.30 e T.38",
          "Consulta, transferência, rechamada",
          "Estacionamento, captura, desvio e retenção",
          "Pêndulo e demais facilidades essenciais",
        ],
        en: [
          "Automatic Call Distributor (ACD/DAC)",
          "Automated Attendant (DISA)",
          "Voicemail",
          "Audio-conference rooms",
          "Intelligent call routing",
          "T.30 and T.38 fax support",
          "Consult, transfer, callback",
          "Parking, pickup, forwarding and hold",
          "Pendulum and other essential PBX features",
        ],
        es: [
          "Distribuidor Automático de Llamadas (DAC)",
          "Atención Automática (DISA)",
          "Buzón de voz",
          "Salas de audioconferencia",
          "Enrutamiento inteligente",
          "Soporte fax T.30 y T.38",
          "Consulta, transferencia, rellamada",
          "Aparcamiento, captura, desvío y retención",
          "Péndulo y demás facilidades esenciales",
        ],
      },
      products: [
        {
          slug: "cip-92200",
          pt: "CIP 92200 — PABX IP all-in-one com gateways integrados",
          en: "CIP 92200 — All-in-one IP PBX with integrated gateways",
          es: "CIP 92200 — PABX IP all-in-one con gateways integrados",
        },
      ],
    },
    {
      id: "cip-850",
      icon: "phone",
      featured: true,
      video: "qeLC0kIMkkE",
      title: {
        pt: "CIP 850 — Central IP Gateway",
        en: "CIP 850 — IP Gateway PBX",
        es: "CIP 850 — Central IP Gateway",
      },
      description: {
        pt: "Gateway IP Intelbras com alta tecnologia e recursos para interagir com várias plataformas de comunicação. Ramais IP em smartphones, tablets, notebooks e PCs — ideal para micro e pequenas empresas, coworkings e provedores que precisam de versatilidade e mobilidade.",
        en: "Intelbras IP gateway with advanced features to interoperate with multiple communication platforms. IP extensions on smartphones, tablets, notebooks and PCs — ideal for SMBs, coworking spaces and providers that need versatility and mobility.",
        es: "Gateway IP Intelbras con alta tecnología para interactuar con varias plataformas de comunicación. Extensiones IP en smartphones, tablets, portátiles y PCs — ideal para PYMEs, coworkings y proveedores que necesitan versatilidad y movilidad.",
      },
      specs: {
        pt: [
          "Até 50 ramais IP (autenticações SIP)",
          "Até 16 chamadas simultâneas",
          "Até 8 interfaces analógicas (FXO / FXS modulares — 4 slots × 2)",
          "Troncos SIP / Entroncamento",
          "Formato rack 19\" — 1U (também montagem em mesa)",
          "Codecs áudio G.711a/u e G.729A; vídeo H.261/H.263/H.264",
        ],
        en: [
          "Up to 50 IP extensions (SIP authentications)",
          "Up to 16 simultaneous calls",
          "Up to 8 analog interfaces (modular FXO / FXS — 4 slots × 2)",
          "SIP trunks / trunking",
          "19\" rack — 1U (desk mount also supported)",
          "G.711a/u and G.729A audio codecs; H.261/H.263/H.264 video",
        ],
        es: [
          "Hasta 50 extensiones IP (autenticaciones SIP)",
          "Hasta 16 llamadas simultáneas",
          "Hasta 8 interfaces analógicas (FXO / FXS modulares — 4 slots × 2)",
          "Troncales SIP / Entroncamiento",
          "Rack 19\" — 1U (también montaje en mesa)",
          "Codecs audio G.711a/u y G.729A; vídeo H.261/H.263/H.264",
        ],
      },
      highlights: {
        pt: [
          "Ramais IP em smartphones, tablets, notebooks e PCs (softphone)",
          "Consulta a portabilidade numérica (economia em chamadas para celular)",
          "Interação com plataformas IP e analógicas",
          "Identificação de chamadas DTMF / FSK",
          "Correio de voz integrado com e-mail",
          "Sala virtual de conferência de voz",
          "Roteamento inteligente de chamadas (LCR)",
          "Bilhetagem (CDR), agenda, DISA e estacionamento de chamadas",
          "Suporte a vídeo-chamadas",
          "QoS para pacotes de voz (TOS para RTP/SIP)",
          "DDNS — não exige IP fixo",
          "Suporte BLF e sinalização SIP",
        ],
        en: [
          "IP extensions on smartphones, tablets, notebooks and PCs (softphone)",
          "Number portability lookup (savings on mobile calls)",
          "Interoperates with IP and analog platforms",
          "DTMF / FSK caller ID",
          "Built-in voicemail with email integration",
          "Virtual voice-conference room",
          "Intelligent call routing (LCR)",
          "CDR billing, directory, DISA and call parking",
          "Video call support",
          "Voice-packet QoS (TOS for RTP/SIP)",
          "DDNS — no fixed IP required",
          "BLF and SIP signaling support",
        ],
        es: [
          "Extensiones IP en smartphones, tablets, portátiles y PCs (softphone)",
          "Consulta de portabilidad numérica (ahorro en llamadas a móviles)",
          "Interoperabilidad con plataformas IP y analógicas",
          "Identificación de llamadas DTMF / FSK",
          "Buzón de voz integrado con email",
          "Sala virtual de conferencia de voz",
          "Enrutamiento inteligente de llamadas (LCR)",
          "Facturación (CDR), agenda, DISA y aparcamiento de llamadas",
          "Soporte de videollamadas",
          "QoS para paquetes de voz (TOS para RTP/SIP)",
          "DDNS — sin IP fijo necesario",
          "Soporte BLF y señalización SIP",
        ],
      },
      products: [
        {
          slug: "cip-850",
          pt: "CIP 850 — Central IP Gateway 1U para até 50 ramais IP",
          en: "CIP 850 — 1U IP Gateway PBX for up to 50 IP extensions",
          es: "CIP 850 — Central IP Gateway 1U para hasta 50 extensiones IP",
        },
      ],
    },
    {
      id: "iad-100",
      icon: "phone",
      featured: true,
      video: "63Zb2GN2Fes",
      title: {
        pt: "IAD 100 — Central Telefónica IP",
        en: "IAD 100 — IP PBX",
        es: "IAD 100 — Central Telefónica IP",
      },
      description: {
        pt: "Central compacta Intelbras que integra comunicação SIP, analógica e celular com recursos de rede Wi-Fi, VPN, Firewall e redundância de dados. Substitui vários equipamentos isolados num único dispositivo — ideal para pequenos escritórios, retalho, clínicas e filiais.",
        en: "Compact Intelbras PBX that combines SIP, analog and cellular communication with built-in Wi-Fi, VPN, Firewall and data redundancy. Replaces several standalone devices in a single appliance — ideal for small offices, retail, clinics and branch sites.",
        es: "Central compacta Intelbras que integra comunicación SIP, analógica y celular con red Wi-Fi, VPN, Firewall y redundancia de datos. Sustituye varios equipos en un único dispositivo — ideal para oficinas pequeñas, retail, clínicas y sucursales.",
      },
      specs: {
        pt: [
          "32 ramais IP + 32 troncos SIP",
          "1 interface FXO (linha analógica) + 1 FXS (ramal analógico)",
          "1 juntor GSM/3G/4G LTE",
          "Até 9 chamadas simultâneas (8 SIP + 1 GSM/FXO)",
          "Roteador Wi-Fi integrado + 4 portas LAN/WAN",
          "VPN, Firewall e redundância de dados",
        ],
        en: [
          "32 IP extensions + 32 SIP trunks",
          "1 FXO (analog line) + 1 FXS (analog extension)",
          "1 GSM/3G/4G LTE channel",
          "Up to 9 simultaneous calls (8 SIP + 1 GSM/FXO)",
          "Integrated Wi-Fi router + 4 LAN/WAN ports",
          "VPN, Firewall and data redundancy",
        ],
        es: [
          "32 extensiones IP + 32 troncales SIP",
          "1 FXO (línea analógica) + 1 FXS (extensión analógica)",
          "1 canal GSM/3G/4G LTE",
          "Hasta 9 llamadas simultáneas (8 SIP + 1 GSM/FXO)",
          "Router Wi-Fi integrado + 4 puertos LAN/WAN",
          "VPN, Firewall y redundancia de datos",
        ],
      },
      highlights: {
        pt: [
          "Integração de tecnologias: ramal analógico, IP e fax",
          "Funciona como roteador Wi-Fi ou cabeado",
          "Até 4 chamadas SIP de vídeo simultâneas",
          "Até 32 grupos de ramais",
          "Calendário e turno automático",
          "Configuração e gestão via web (PT)",
          "Conectividade 4G LTE como backup de internet",
          "VPN para acesso remoto seguro",
          "Firewall integrado",
        ],
        en: [
          "Technology integration: analog, IP and fax extensions",
          "Operates as Wi-Fi or wired router",
          "Up to 4 simultaneous SIP video calls",
          "Up to 32 extension groups",
          "Schedule & automatic day/night mode",
          "Web-based configuration & management (PT)",
          "4G LTE connectivity as internet backup",
          "VPN for secure remote access",
          "Built-in firewall",
        ],
        es: [
          "Integración de tecnologías: analógico, IP y fax",
          "Funciona como router Wi-Fi o cableado",
          "Hasta 4 videollamadas SIP simultáneas",
          "Hasta 32 grupos de extensiones",
          "Calendario y turno automático",
          "Configuración y gestión vía web (PT)",
          "Conectividad 4G LTE como respaldo de internet",
          "VPN para acceso remoto seguro",
          "Firewall integrado",
        ],
      },
      products: [
        {
          slug: "iad-100",
          pt: "IAD 100 — Central Telefónica IP all-in-one com Wi-Fi, VPN e 4G",
          en: "IAD 100 — All-in-one IP PBX with Wi-Fi, VPN and 4G",
          es: "IAD 100 — Central Telefónica IP all-in-one con Wi-Fi, VPN y 4G",
        },
      ],
    },
    {
      id: "external",
      icon: "shield",
      title: { pt: "Para áreas externas", en: "For outdoor areas", es: "Para áreas externas" },
      description: {
        pt: "Identifique invasores, proteja perímetros e adapte-se a qualquer cenário ao ar livre.",
        en: "Identify intruders, protect perimeters and adapt to any outdoor scenario.",
        es: "Identifica intrusos, protege perímetros y adáptate a cualquier escenario exterior.",
      },
      products: [
        { slug: "perimeter-protection", pt: "Proteção perimetral", en: "Perimeter protection", es: "Protección perimetral" },
        { slug: "surveillance-drone", pt: "Drones de vigilância", en: "Surveillance drones", es: "Drones de vigilancia" },
        { slug: "two-way-radio", pt: "Rádios comunicadores", en: "Two-way radios", es: "Radios comunicadores" },
        { slug: "automatic-barrier", pt: "Cancelas automáticas", en: "Automatic barriers", es: "Barreras automáticas" },
        { slug: "thermal-camera", pt: "Câmaras térmicas", en: "Thermal cameras", es: "Cámaras térmicas" },
        { slug: "ai-camera", pt: "Câmaras com Inteligência Artificial", en: "AI-powered cameras", es: "Cámaras con IA" },
        { slug: "barrier-sensor", pt: "Sensores de barreira", en: "Barrier sensors", es: "Sensores de barrera" },
      ],
    },
    {
      id: "internal",
      icon: "door",
      title: { pt: "Para áreas internas", en: "For indoor areas", es: "Para áreas internas" },
      description: {
        pt: "Controlo de acessos, autenticação e conectividade para ambientes corporativos, comerciais e residenciais.",
        en: "Access control, authentication and connectivity for corporate, retail and residential spaces.",
        es: "Control de accesos, autenticación y conectividad para entornos corporativos, comerciales y residenciales.",
      },
      products: [
        { slug: "access-control-people", pt: "Controlo e gestão de pessoas", en: "People access & management", es: "Control y gestión de personas" },
        { slug: "business-router", pt: "Roteadores empresariais", en: "Business routers", es: "Routers empresariales" },
        { slug: "ip-phone", pt: "Telefones IP", en: "IP phones", es: "Teléfonos IP" },
        { slug: "turnstile", pt: "Catracas com controlador de acessos", en: "Turnstiles with access control", es: "Torniquetes con control de acceso" },
        { slug: "sliding-door-automation", pt: "Automatizadores de portas deslizantes", en: "Sliding-door automation", es: "Automatizadores de puertas corredizas" },
      ],
    },
    {
      id: "parking",
      icon: "car",
      title: { pt: "Para áreas de estacionamento", en: "For parking areas", es: "Para áreas de estacionamiento" },
      description: {
        pt: "Controlo automatizado de entrada e saída de veículos, com menos filas e identificação precisa.",
        en: "Automated vehicle entry and exit with accurate identification and shorter queues.",
        es: "Control automatizado de entrada y salida de vehículos, con menos filas e identificación precisa.",
      },
      products: [
        { slug: "vehicle-management", pt: "Controlo e gestão de veículos", en: "Vehicle access & management", es: "Control y gestión de vehículos" },
        { slug: "hd-camera", pt: "Câmaras de alta resolução", en: "High-resolution cameras", es: "Cámaras de alta resolución" },
        { slug: "automatic-barrier", pt: "Cancelas automáticas", en: "Automatic barriers", es: "Barreras automáticas" },
        { slug: "lpr-camera", pt: "Câmaras com leitura de matrículas (LPR)", en: "License-plate recognition cameras (LPR)", es: "Cámaras con lectura de matrículas (LPR)" },
        { slug: "ev-charger", pt: "Carregadores para veículos elétricos", en: "EV chargers", es: "Cargadores para vehículos eléctricos" },
        { slug: "solar-light", pt: "Luminárias solares", en: "Solar lighting", es: "Luminarias solares" },
      ],
    },
    {
      id: "management",
      icon: "dashboard",
      title: { pt: "Para controlo e administração", en: "For control & administration", es: "Para control y administración" },
      description: {
        pt: "Monitorização, gestão de rede e continuidade energética para os ambientes do seu negócio.",
        en: "Monitoring, network management and power continuity for your business environments.",
        es: "Monitoreo, gestión de red y continuidad energética para los entornos de tu negocio.",
      },
      products: [
        { slug: "monitoring-station", pt: "Centrais de monitorização", en: "Monitoring stations", es: "Centrales de monitoreo" },
        { slug: "defense-ia-software", pt: "Software Defense IA Lite", en: "Defense IA Lite software", es: "Software Defense IA Lite" },
        { slug: "video-wall", pt: "Video walls", en: "Video walls", es: "Video walls" },
        { slug: "floor-rack", pt: "Racks de piso", en: "Floor racks", es: "Racks de piso" },
        { slug: "two-way-radio", pt: "Rádios comunicadores", en: "Two-way radios", es: "Radios comunicadores" },
        { slug: "nobreak-ups", pt: "Nobreaks / UPS", en: "UPS / nobreaks", es: "Nobreaks / UPS" },
      ],
    },
    {
      id: "prevention",
      icon: "fire",
      title: { pt: "Para prevenção", en: "For prevention", es: "Para prevención" },
      description: {
        pt: "Prevenção de incêndio eficaz, combinando alarmes, sinalização e monitorização térmica.",
        en: "Effective fire prevention combining alarms, signage and thermal monitoring.",
        es: "Prevención de incendios eficaz, combinando alarmas, señalización y monitoreo térmico.",
      },
      products: [
        { slug: "fire-alarm-panel", pt: "Centrais de alarme de incêndio", en: "Fire alarm control panels", es: "Centrales de alarma de incendio" },
        { slug: "smoke-detector", pt: "Detetores de fumo", en: "Smoke detectors", es: "Detectores de humo" },
        { slug: "emergency-light", pt: "Blocos autónomos de iluminação de emergência", en: "Self-contained emergency lighting", es: "Bloques autónomos de iluminación de emergencia" },
        { slug: "exit-sign", pt: "Placas de sinalização", en: "Exit & safety signage", es: "Placas de señalización" },
        { slug: "manual-call-point", pt: "Acionadores manuais de emergência", en: "Manual emergency call points", es: "Accionadores manuales de emergencia" },
      ],
    },
    {
      id: "telephony",
      icon: "phone",
      title: { pt: "Telefonia & Redes", en: "Telephony & Networks", es: "Telefonía & Redes" },
      description: {
        pt: "Portfólio completo para comunicação corporativa e infraestrutura de rede.",
        en: "Full portfolio for corporate communication and network infrastructure.",
        es: "Portafolio completo para comunicación corporativa e infraestructura de red.",
      },
      products: [
        { slug: "pabx-central", pt: "Centrais PABX híbridas", en: "Hybrid PBX systems", es: "Centrales PABX híbridas" },
        { slug: "ip-phone", pt: "Telefones secretária IP", en: "IP secretary phones", es: "Teléfonos secretaría IP" },
        { slug: "dect-phone", pt: "Telefones wireless (DECT)", en: "Wireless phones (DECT)", es: "Teléfonos wireless (DECT)" },
        { slug: "analog-phone", pt: "Telefones híbridos e analógicos", en: "Hybrid & analog phones", es: "Teléfonos híbridos y analógicos" },
        { slug: "poe-switch", pt: "Switches PoE de 6 a 48 portas com uplinks de fibra", en: "6-48 port PoE switches with fiber uplinks", es: "Switches PoE de 6 a 48 puertos con uplinks de fibra" },
        {
          slug: "gid-308-base",
          pt: "GID 308 B — Estação base DECT multicélula (até 40 bases, 200 utilizadores)",
          en: "GID 308 B — Multicell DECT base station (up to 40 bases, 200 users)",
          es: "GID 308 B — Estación base DECT multicélula (hasta 40 bases, 200 usuarios)",
        },
        {
          slug: "gid-308-handset",
          pt: "GID 308 H — Terminal DECT com visor colorido, viva-voz e 200 h stand-by",
          en: "GID 308 H — DECT handset with color display, speakerphone and 200 h stand-by",
          es: "GID 308 H — Terminal DECT con pantalla a color, manos libres y 200 h de stand-by",
        },
        {
          slug: "cr-200",
          pt: "CR 200 — Gateway IP/GSM com até 8 canais, SMS, Fax e call back",
          en: "CR 200 — IP/GSM gateway with up to 8 channels, SMS, fax and call back",
          es: "CR 200 — Gateway IP/GSM con hasta 8 canales, SMS, fax y call back",
        },
      ],
    },
  ],
};
